module.exports = __webpack_public_path__ + "static/animated-illustration-4-745d8e73b0c9edeb3786fc739cb7bf33.gif";